import React from 'react';

const Hashtag = () => {
  return (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 9h16M4 15h16M10 3L8 21M16 3l-2 18"
        stroke="#00BC8F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default React.memo(Hashtag);
